import {h} from 'preact';
import {cxMenu} from '../../styles';
import MobileNav from '../../';
import Icon from '@components/common/Icon';

const ItemNode = ( {sysId, title, url, cssClass} ) =>
    <li>
        <div data-menu-id={sysId} className={cxMenu.item}>
            {MobileNav.renderIcon( cssClass )}
            <span className={cxMenu.itemLabel}>{title}</span>
            <Icon.ui name="arrow-right" className="text-xl ml-4"/>
        </div>
    </li>;

export default ItemNode;